export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 40;
export const ZONE_SIDEBAR_WIDTH = 400;
export const DEFAULT_ORIGIN_CENTER: [number, number] = [210140.5, 5869801.3]; // FRANCE
export const DEFAULT_TEXT_FIXED_SIZE_PX = 16;
export const SLIDER_MAX_TEXT_FIXED_SIZE_PX = 100;
export const MAX_TEXT_FIXED_SIZE_PX = 200;
export const MIN_IMAGE_SCREEN_PX = 30;
export const SHOW_SHAPE_MEASURES = false;
